import React, { useState, useEffect, useContext } from 'react';
import { Flame } from 'lucide-react';
import { AppContext } from '../context/AppContext';
import PostCard from '../components/PostCard';
import SkeletonLoader from '../components/SkeletonLoader';
import EmptyState from '../components/EmptyState';

export default function Trending() {
  const [loading, setLoading] = useState(true);
  const [trendingPosts, setTrendingPosts] = useState([]);
  const { posts } = useContext(AppContext);

  useEffect(() => {
    const fetchTrending = async () => {
      try {
        const getApiBase = () => {
          const hostname = window.location.hostname;
          if (hostname === "localhost" || hostname === "127.0.0.1") {
            return "http://localhost:8000/api";
          }
          if (hostname.startsWith("10.") || hostname.startsWith("192.") || hostname.startsWith("172.")) {
            return `http://${hostname}:8000/api`;
          }
          return "https://selffo-backend.onrender.com/api";
        };
        const API_BASE = getApiBase();
        const res = await fetch(`${API_BASE}/posts/trending/`);
        if (res.ok) {
          const data = await res.json();
          setTrendingPosts(data.results || data);
        }
      } catch (err) {
        console.error("Failed to fetch trending:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTrending();
  }, []);

  return (
    <div className="flex flex-col">
      <div className="p-4 border-b border-slate-100 dark:border-slate-900/50">
        <div className="flex items-center gap-2 text-orange-500 mb-1">
          <Flame className="w-5 h-5" />
          <span className="font-bold uppercase tracking-widest text-[11px]">Trending</span>
        </div>
        <h1 className="text-xl font-bold tracking-tight text-slate-900 dark:text-white">Most Viral Confessions</h1>
      </div>

      {loading ? (
        <SkeletonLoader />
      ) : trendingPosts.length > 0 ? (
        <div className="flex flex-col">
          {trendingPosts.map(post => (
            <PostCard key={post.id} post={post} />
          ))}
        </div>
      ) : (
        <EmptyState message="Nothing is trending right now." />
      )}
    </div>
  );
}
